// Hooks
import { useSnackbar } from '@/contexts/SnackBarContext'
import type { IServiceError } from '@/types/error'

export default function useManageResponse() {
  const showSnackBar = useSnackbar()
  return function manageResponse<T>({ response, defaultValue }: { response: T | IServiceError; defaultValue: T }) {
    if (typeof response === 'object' && response !== null && 'error' in response) {
      showSnackBar(response.error.message, 'error')
      return defaultValue
    }
    return response
  }
}
